import { Component, Signal, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { BrandingService, GetBrandingResult } from '../../data-access/branding.service';

@Component({
    selector: 'rl-core-receipt-layout',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './receipt-lookup-layout.component.html',
    styleUrl: './receipt-lookup-layout.component.scss',
})
export class ReceiptLookupLayoutComponent {
    readonly #brandingService: BrandingService = inject(BrandingService);
    readonly brandingData: Signal<GetBrandingResult | undefined> = toSignal(
        this.#brandingService.ensureBrandingLoaded$()
    );

    constructor() {
        effect(() => {
            const branding: GetBrandingResult | undefined = this.brandingData();

            if (branding && !branding.loading && branding.data?.branding.logoUrl) {
                this.setFavicon();
            }
        });
    }

    setFavicon(): void {
        const favicon: HTMLLinkElement | null = document.querySelector('link[rel="icon"]');
        if (!favicon) {
            console.warn('Favicon element not found');
            return;
        }

        if (favicon !== null) {
            favicon.href = this.#brandingService.getLogoUrl() || 'favicon.ico'; // Fallback to default favicon if logo URL is not available
        }
    }
}
